import { AxiosRequestConfig } from 'axios'
import { Get } from './Get'
import { Post } from './Post'
import { Put } from './Put'
import { Delete } from './Delete'
import { SYSTEM_CONSTANT } from '~/constants/system-constant'
import {
  CreateOpenIddictApplicationDto,
  UpdateOpenIddictApplicationDto,
} from './OpenIddictApplication.interface'

class OpenIddictApplicationServiceController {
  private get url() {
    return `${SYSTEM_CONSTANT.IDENTITY_SERVER_URL}/OpenIddictApplications`
  }

  public Get = {
    getAll: (options: AxiosRequestConfig = {}) => Get(this.url, options),
    getById: (id: string, options: AxiosRequestConfig = {}) =>
      Get(`${this.url}/${id}`, options),
  }

  public Post = {
    create: (
      data: CreateOpenIddictApplicationDto,
      options: AxiosRequestConfig = {},
    ) => Post(this.url, data, options),
  }

  public Put = {
    update: (
      id: string,
      data: UpdateOpenIddictApplicationDto,
      options: AxiosRequestConfig = {},
    ) => Put(`${this.url}/${id}`, data, options),
  }

  public Delete = {
    delete: (id: string, options: AxiosRequestConfig = {}) =>
      Delete(`${this.url}/${id}`, {}, options),
    deleteLogo: (id: string, options: AxiosRequestConfig = {}) =>
      Delete(`${this.url}/${id}/logo`, {}, options),
  }

  // multipart/form-data riêng cho logo — Create/Update application vẫn là application/json, không đổi
  // contract hiện tại của 2 endpoint đó (xem backend OpenIddictApplicationsController).
  public UploadLogo = (id: string, file: File, options: AxiosRequestConfig = {}) => {
    const formData = new FormData()
    formData.append('logo', file)
    return Post(`${this.url}/${id}/logo`, formData, options)
  }
}

export const OpenIddictApplicationService = new OpenIddictApplicationServiceController()
